import { createContext, useContext } from 'react';

type Props = {
  children: React.ReactNode;
  value: boolean;
};

const IsInGlassContext = createContext<boolean>(false);

export function IsInGlassProvider({ value, children }: Props) {
  return (
    <IsInGlassContext.Provider value={value}>
      {children}
    </IsInGlassContext.Provider>
  );
}

export function useIsInGlass() {
  return useContext(IsInGlassContext);
}
